import { _values, } from '../util/data';
import { _claimId, _freeId, } from '../service/id-set';
const _registerRoute = (route) => {
    const panes = route.p();
    _claimId(panes.idn());
    _routesById[panes.id()] = route;
    _updateRouteList();
}, _unregisterRoute = (route) => {
    const panes = route.p();
    delete _routesById[panes.id()];
    _freeId(panes.idn());
    _updateRouteList();
}, _updateRouteList = () => {
    _routeList = _values(_routesById);
}, _routeById = (routeId) => _routesById[routeId], _routes = () => _routeList, _routesById = {};
let _routeList = [];
export { _registerRoute, _unregisterRoute, _routeById, _routes, };
